import { useRouter } from "next/router";
import ReactPaginate from "react-paginate";

export default function Pagination({ meta = [] }) {

  const router = useRouter();
  const handlePageClick = function (pages) {
    const queryParams = router.query;
    queryParams.page = pages.selected + 1;
    router.push({ query: queryParams });
  }
  return (
    <>
      <ReactPaginate
        onPageChange={handlePageClick}
        pageRangeDisplayed={7}
        pageCount={meta?.last_page}
        disableInitialCallback={true}
        containerClassName='pagination d-flex justify-content-center'
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        nextLabel={<i className="bi bi-chevron-compact-right"></i>}
        previousLabel={<i className="bi bi-chevron-compact-left"></i>}
        activeClassName="page-item active"
        pageLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
      
      />
    </>
  )
}
